import React, { useEffect, useState } from "react";
import MPSBarLoader from "../../../../components/MPSBarLoader";
import fileService from "../../../../services/fileService";

// Resolves an audio url the way the app needs it: files go through
// fileService, which returns absolute urls unchanged and turns protected
// relative ones into blob urls.
export function useResolvedAudioUrl(url) {
  const [resolvedUrl, setResolvedUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!url) {
      return undefined;
    }
    fileService
      .getFile(url)
      .then((res) => {
        if (!cancelled) setResolvedUrl(res);
      })
      .catch(() => {
        // Fail silently — audio just won't load.
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  return resolvedUrl;
}

export default function ContentAudio({ url }) {
  const src = useResolvedAudioUrl(url);

  return (
    <div className="info-panel-content-audio">
      {src ? (
        <audio
          controls
          src={src}
          preload="metadata"
          style={{ width: "100%" }}
        >
          Sorry, your browser doesn't support embedded audio.
        </audio>
      ) : (
        <div className="info-panel-content-audio__loader">
          <MPSBarLoader />
        </div>
      )}
    </div>
  );
}
